module.exports = __webpack_public_path__ + "img/Nature_Communications_2025.8f44fda7.jpg";